import React from 'react';
import './Quiz.css';

const QuizContainer = ({ 
  title = "Quiz", 
  currentStep, 
  totalSteps, 
  isLoading, 
  loadingMessage,
  children 
}) => {
  if (isLoading) {
    return (
      <div className="quiz-container">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <h2>{loadingMessage?.title || "Processing Your Results..."}</h2>
          <p>{loadingMessage?.description || "Please wait while we analyze your responses."}</p>
          {loadingMessage?.note && (
            <div style={{ marginTop: '2rem', fontSize: '0.9rem', color: 'var(--soft-gray)' }}>
              {loadingMessage.note}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="quiz-container">
      {/* Progress bar - only show if not on results step */}
      {currentStep <= totalSteps && (
        <div className="progress-bar">
          <div className="progress-header">
            <h1>{title}</h1>
            <div className="step-indicator">Step {currentStep} of {totalSteps}</div>
          </div>
          <div className="progress-track">
            <div 
              className="progress-fill" 
              style={{ width: `${(currentStep / totalSteps) * 100}%` }}
            />
          </div>
        </div>
      )}

      {/* Quiz content */}
      <div className="quiz-content">
        {children}
      </div>
    </div>
  );
};

export default QuizContainer; 